import React from 'react';
import { CRMOrganizationSection } from './CRMOrganizationSection';
import Styled from './style';
import { useOrganizationDetails } from '../../../../../../../features/organizations/hooks/useOrganizationDetails';
import Section from '../../../../_Misc/Section';
import { UpdateLoader } from '../../../../../../../componentsV2/UpdateLoader';
import { PropertyMappingProvider } from '../../../../../../../features/crm/property-mapping/components/PropertyMappingProvider';

const { Container } = Styled;

export const CRMSetupSection: React.FC<
  { onSave: VoidFunction } & { ref: React.Ref<HTMLDivElement> }
> = React.forwardRef<HTMLDivElement, { onSave: VoidFunction }>((props, ref) => {
  const { isFetching, permissions } = useOrganizationDetails();

  return (
    <Container>
      {isFetching ? (
        <UpdateLoader min />
      ) : (
        <PropertyMappingProvider>
          <CRMOrganizationSection
            disableUserInteractions={!permissions.connectPrimaryCrm}
            onSave={props.onSave}
          />
        </PropertyMappingProvider>
      )}
    </Container>
  );
});
